import { em, math } from 'polished'
import styled, { css } from 'styled-components'

import { H4 } from 'styles/components/typography'
import { setBackground } from 'utils/styled/setBackground'

const personBlockHeight = em(220)
const contactsCardIndent = em(40)
const personNameWidth = em(110)

export const Wrapper = styled.div`
  margin: 0 auto;
  position: relative;
  max-width: em(400);
  ${({ personPhoto }) =>
    personPhoto &&
    css`
      padding-top: ${p => em(p.theme.indents.baseIndentXs)};
    `}

  ${p => p.theme.mq.upMd} {
    align-self: flex-start;
    flex: 0 1 auto;
    margin: 0;
    max-width: none;
    /*
     * 50%                                    - width of card on tablet devices
     * contactsCardIndent                     - indents between cards and outside
     * 50% - contactsCardIndent / 2           - card width with considering indents
     */
    width: calc(50% - ${contactsCardIndent} / 2);
    transition: transform ${p => p.theme.animation.timeLong} ${p =>
  p.theme.animation.cubicBezier};
    &:not(:first-child),
    &:not(:last-child) {
      margin-top: ${contactsCardIndent};
    }

    ${({ withTransform, isTranslated }) =>
      withTransform &&
      !isTranslated &&
      css`
        &:nth-child(2n + 1) {
          transform: translateY(${math(`-${contactsCardIndent} * 3`)});
        }
        &:nth-child(2n + 2) {
          transform: translateY(${contactsCardIndent});
        }
      `}

    ${({ withTransform, isTranslated, personPhoto }) =>
      withTransform &&
      personPhoto &&
      !isTranslated &&
      css`
        &:nth-child(2n + 1) {
          transform: translateY(${math(`-${contactsCardIndent} * 2`)});
        }
      `}


    ${({ personPhoto }) =>
      personPhoto &&
      css`
        padding-top: 0;
      `}
  }

  ${p => p.theme.mq.upLg} {
    flex: 1 1 0;
    max-width: none;
    width: auto;
    &:not(:last-child) {
      margin-bottom: 0;
    }
    & + & {
      margin-left: ${contactsCardIndent};
    }
  }
`

export const IconBox = styled.div`
  background-color: ${p => p.theme.colors.lilacDark};
  height: ${math(`${contactsCardIndent} * 2`)};
  left: ${math(`${contactsCardIndent} / 2`)};
  padding: ${math(`${contactsCardIndent} / 3`)};
  position: absolute;
  top: ${p =>
    p.personPhoto
      ? math(`${personBlockHeight} - ${contactsCardIndent}`)
      : math(`${contactsCardIndent} / 2`)};
  width: ${math(`${contactsCardIndent} * 2`)};

  ${p => p.theme.mq.upMd} {
    height: ${math(`${contactsCardIndent} * 2`)};
    left: ${contactsCardIndent};
    top: ${p =>
      p.personPhoto ? math(`${personBlockHeight} - ${contactsCardIndent}`) : 0};
    width: ${math(`${contactsCardIndent} * 2`)};
  }
`

export const InnerBox = styled.div`
  padding-top: ${p => (p.personPhoto ? 0 : contactsCardIndent)};
`

export const DepartmentWrapper = styled.div`
  padding: ${em(20)} ${em(20)} ${em(40)};
  background: ${p => p.theme.colors.grayOp06NonTransp};

  ${p => p.theme.mq.upMd} {
    padding: ${em(40)};
  }
`

export const DepartmentNameBox = styled.div`
  padding-top: ${em(40)};

  ${p => p.theme.mq.upMd} {
    padding-top: ${em(20)};
  }
`

export const DepartmentName = styled(H4)`
  padding-top: ${em(10)};
`

export const PersonBox = styled.div`
  background: #f8c07f center/auto 100% no-repeat;
  ${p => setBackground('png', p.image, { xs: 460 }, false)};
  height: ${personBlockHeight};
  position: relative;
`

export const PersonName = styled.div`
  position: absolute;
  top: ${math(`${contactsCardIndent} / 2`)};
  left: ${math(`${contactsCardIndent} / 2`)};
  max-width: ${personNameWidth};
  color: ${p => p.theme.colors.whiteOp6};
  line-height: 1.2;

  ${p => p.theme.mq.upMd} {
    left: ${contactsCardIndent};
    top: ${contactsCardIndent};
  }
`
